import {
  GET_VARIAVEIS_GLOBAIS_INIT,
  GET_VARIAVEIS_GLOBAIS_SUCCESS,
  UPDATE_VARIAVEIS_GLOBAIS_INIT,
  UPDATE_VARIAVEIS_GLOBAIS_SUCCESS,
  ERROR_VARIAVEIS_GLOBAIS_MSG,
  CLEAR_FLAGS_VARIAVEIS_GLOBAIS
} from '../../actionTypes';
import { IVariavelGlobal } from 'src/integracoes/servicos/mongo-atlas/modelos/IVariaveisGlobais';

const INIT_STATE = {
  variaveisGlobais: [] as IVariavelGlobal[],
  loading: false,
  loadingSave: false,
  isUpdated: false,
  isError: false,
  msg: ''
};

export default (state = INIT_STATE, action: any) => {
  switch (action.type) {
    case GET_VARIAVEIS_GLOBAIS_INIT:
      return { ...state, loading: true };
    case GET_VARIAVEIS_GLOBAIS_SUCCESS: {
      const { variaveisGlobais } = action.payload;
      return { ...state, loading: false, variaveisGlobais };
    }
    case UPDATE_VARIAVEIS_GLOBAIS_INIT:
      return { ...state, loadingSave: true, isUpdated: false, isError: false };
    case UPDATE_VARIAVEIS_GLOBAIS_SUCCESS: {
      const { msg } = action.payload;
      return { ...state, loadingSave: false, isUpdated: true, msg };
    }
    case ERROR_VARIAVEIS_GLOBAIS_MSG: {
      const { msg } = action.payload;
      return { ...state, loading: false, loadingSave: false, isError: true, msg };
    }
    case CLEAR_FLAGS_VARIAVEIS_GLOBAIS:
      return { ...state, isUpdated: false, isError: false, loadingSave: false, msg: '' };
    default:
      return { ...state };
  }
};
